
import Image from "./Image";
import { Boxes, CalendarCheck, Gauge, Wrench, BarChart3, ShieldCheck } from "lucide-react";
import { useFeatureCardPlaying } from "./FeatureCard";
/* ── FLEET — a single hero vehicle (2025 BMW X5, black) angled to the left. The source is a
   studio product shot on a TRANSPARENT background with a baked floor reflection, so it drops
   straight onto the dark card with no blend trick. A small purple-tinted glow sits behind the
   body only (not the reflection) as a spotlight. Six glass badges ring the car, each naming a
   fleet-management surface. The badges rest hidden (the start frame) and reveal with a
   staggered rise when the card plays (hover on desktop, in view on mobile). */
const BADGES = [
    { icon: Boxes, label: "Inventory", pos: "left-[6%] top-[12%]" },
    { icon: CalendarCheck, label: "Availability", pos: "right-0 top-[8%]" },
    { icon: Gauge, label: "Utilization", pos: "left-0 top-1/2 -translate-y-1/2" },
    { icon: Wrench, label: "Maintenance", pos: "right-0 top-1/2 -translate-y-1/2" },
    { icon: BarChart3, label: "Analytics", pos: "left-[6%] bottom-[14%]" },
    { icon: ShieldCheck, label: "Compliance", pos: "right-[4%] bottom-[10%]" },
];
export function FleetVehiclePreview() {
    const playing = useFeatureCardPlaying();
    return (<div className="relative flex w-full items-center justify-center" role="img" aria-label="A 2025 BMW X5 M fleet vehicle on a reflective floor, ringed by fleet-management badges: Inventory, Availability, Utilization, Maintenance, Analytics and Compliance">
      {/* Image box sized to the car so the glow lines up with it. */}
      <div className="relative w-full max-w-[300px]">
        {/* Soft purple hue behind the vehicle. It breathes gently at rest and pulses harder
            while the card plays. The animation lives in `.fleet-hue` (globals.css). */}
        <div aria-hidden="true" data-playing={playing} className="fleet-hue pointer-events-none absolute inset-0" style={{
            backgroundImage: "radial-gradient(60% 55% at 50% 46%, rgba(196,158,255,0.7) 0%, rgba(160,110,240,0.42) 40%, rgba(120,70,210,0.16) 66%, transparent 80%)",
        }}/>

        {/* Vehicle on a real transparent background (white studio backdrop keyed out), so it
            drops straight onto the dark card with no blend trick or hard rectangle. */}
        <Image src="/images/fleet/bmw-x5-fleet.webp" alt="2025 BMW X5 M in black, angled to the left on a reflective floor" width={600} height={600} sizes="(max-width: 1024px) 90vw, 45vw" className="relative z-10 h-auto w-full object-contain" priority={false}/>
      </div>

      {/* Six fleet-management badges ringing the vehicle. */}
      {BADGES.map(({ icon: Icon, label, pos }, i) => (<span key={label} className={`absolute ${pos} z-30 inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-black/50 px-2.5 py-1.5 font-sans text-[11px] font-medium text-white shadow-lg backdrop-blur-md`} style={{
                opacity: playing ? 1 : 0,
                transform: playing ? "translateY(0)" : "translateY(6px)",
                transition: "opacity 420ms ease, transform 420ms cubic-bezier(0.34,1.56,0.64,1)",
                transitionDelay: playing ? `${i * 110}ms` : "0ms",
            }}>
          <Icon aria-hidden="true" strokeWidth={1.75} className="h-3.5 w-3.5 shrink-0"/>
          {label}
        </span>))}
    </div>);
}
